<template>
  <div class="input-wrapper">
    <label v-if="label" v-text="label" />
    <div
      class="input-group input-copy"
      v-tooltip="{
        content: 'Copié',
        shown: state.copied,
        triggers: [],
      }"
    >
      <input type="text" :value="value" disabled />
      <Button
        class="secondary outline icon square sm"
        icon="bi bi-layers"
        @click="copy()"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { copyToClipboard } from "@/composables/utils.js";

const state = reactive({
  copied: false,
});

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  trim: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
  },
});

function copy() {
  copyToClipboard(props.value, props.trim);
  state.copied = true;
  setTimeout(() => {
    state.copied = false;
  }, 2500);
}
</script>
